module.exports = __webpack_public_path__ + "static/media/transilluminator-closed.abe0d279.svg";